import { theme as antdTheme, Button, ConfigProvider, Result } from 'antd'
import Head from 'next/head'
import Link from 'next/link'
import { useIntl } from 'react-intl'

import { defaultTheme } from '@/styles/theme'
import { buildI18nFunction, composePageTitle } from '@/utils/messages'

const COMPONENT_ID = 'ResultErrorUnAuthorized'

const { defaultAlgorithm } = antdTheme

export function ResultErrorUnAuthorized(): JSX.Element {
  const t = buildI18nFunction(useIntl().formatMessage)

  return (
    <ConfigProvider
      theme={{
        ...defaultTheme,
        algorithm: defaultAlgorithm,
      }}
    >
      <div
        data-cy={COMPONENT_ID}
        style={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          justifyContent: 'center',
        }}
      >
        <Head>
          <title>
            {composePageTitle(t(`${COMPONENT_ID}.Head.title`).toString())}
          </title>
        </Head>
        <Result
          extra={
            <Button>
              <Link href="/">{t(`${COMPONENT_ID}.extra.callToAction`)}</Link>
            </Button>
          }
          status="403"
          title={t(`${COMPONENT_ID}.title`)}
          subTitle={t(`${COMPONENT_ID}.subTitle`)}
        />
      </div>
    </ConfigProvider>
  )
}
